"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTextValueControl = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../../../Text");
function createTextValueControl({ valueRenderer = (value, disabled) => (react_1.default.createElement(Text_1.Text, { view: disabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary }, value)) } = {}) {
    return function TextValueControlRenderer({ disabled, value }) {
        const textValueElement = valueRenderer(value, Boolean(disabled));
        const view = disabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary;
        if (typeof textValueElement === 'string') {
            return react_1.default.createElement(Text_1.Text, { view: view }, textValueElement);
        }
        return textValueElement;
    };
}
exports.createTextValueControl = createTextValueControl;
//# sourceMappingURL=textValueControlRenderer.js.map